import { render, staticRenderFns } from "./PT360SecretQuestion.vue?vue&type=template&id=d9d3a906&"
import script from "./PT360SecretQuestion.vue?vue&type=script&lang=js&"
export * from "./PT360SecretQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports